export enum EarningType {
  EARN_BY_AMOUNT = 'EARN_BY_AMOUNT',
  EARN_BY_PURCHASE_ITEM = 'EARN_BY_PURCHASE_ITEM',
}

export enum RewardType {
  DISCOUNT_ENTIRE_SALE = 'DISCOUNT_ENTIRE_SALE',
  PRODUCT_DISCOUNT = 'PRODUCT_DISCOUNT',
  FREE_ITEM = 'FREE_ITEM',
}

export enum EventType {
  SIGN_UP = 'SIGN_UP',
  NONE = 'NONE',
  BIRTHDAY = 'BIRTHDAY',
}

export enum LoyaltyNotificationType {
  ENROLL_SUCCESS = 'ENROLL_SUCCESS',
  REDEEMED_REWARDS = 'REDEEMED_REWARDS',
  EARN_NEW_POINT = 'EARN_NEW_POINT',
  REFUND_POINTS = 'REFUND_POINTS',
}

export enum LoyaltyNotificationMode {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}

export enum PointEvent {
  EARN_POINT = 'EARN_POINT',
  REDEEM_POINT = 'REDEEM_POINT',
}

export enum LoyaltyEnrolmentSource {
  POS = 'POS',
  ONLINE = 'ONLINE',
  CUSTOMER_DISPLAY_SCREEN = 'CUSTOMER_DISPLAY_SCREEN',
  BACK_OFFICE = 'BACK_OFFICE',
}

export enum LoyaltyActivityType {
  ENROLLED = 'ENROLLED',
  DELISTED = 'DELISTED',
  ADJUSTED = 'ADJUSTED',
  EARNED_POINTS = 'EARNED_POINTS',
  REFUNDED_POINTS = 'REFUNDED_POINTS',
  REDEEMED_REWARDS = 'REDEEMED_REWARDS',
  REFUNDED_REWARDS = 'REFUNDED_REWARDS',
}
